export default __webpack_public_path__ + "static/media/headbutt_dino_icon.1079419d.png";